<template>
  <h1 v-if="page && eventItem">
    <router-link :to="'/events/'+ eventItem.id">
      <i class="fas fa-long-arrow-alt-right"></i> {{ eventItem.title }}
    </router-link>
  </h1>
  
  <OfflineMode />

  <div v-if="!eventItem" class="container-fluid alert alert-danger text-center box-fixed">
    <strong>No event found!</strong>
  </div>

  <div v-if="eventItem && menuItem.id == 'participants' && ContactItems" id="search-box" class="sticky-top container-fluid">
    <div class="input-group py-3">
      <input class="form-control" type="search" placeholder="Search" aria-label="Search" v-model="search">
      <button @click="clearSearch" class="btn btn-outline-secondary" type="button" id="button-clear">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
  
  <div id="event-menu" v-if="eventItem" class="container-fluid container-lg">
    <div :class="[(!page) ? 'py-lg-4' : '', 'row py-0 justify-content-center']">

      <div v-if="!page" class="col-12 col-lg-8 gx-0 gx-lg-4">
				
        <h1 v-if="!eventItem.image">{{ eventItem.title }}</h1>
        <img v-if="eventItem.image" :src="`${publicPath}`+ eventItem.image" v-bind:alt="eventItem.title" class="img-fluid my-2" />
				
				<NewsList 
					v-if="eventItem.news"
					:news="eventItem.news" 
					/>
      </div>

      <div :class="['col-12', (!page) ? 'col-lg-4' : 'col-lg-auto']">
      
        <div v-if="menuItem.type == 'list'" class="menulist mb-3">
        
          <h2 v-if="page" class="text-center">{{menuItem.title}}</h2>
          
          <div v-for="subItem in menuItem.items"
            :key="subItem.id">
            
            <EventPage 
              v-if="(page || subpage) && menuItem.items.length == 0 && subItem.type == 'page'" 
              :pageItem="menuItem.items[0]" :pageTitle="menuItem.items[0].title"
							:backpage="getBackpage" />
              
            <MenuItemSubMenu  
              v-if="!page && subItem.type !== 'link' && subItem.type !== 'pdf' && subItem.items  && menuItem.items.length > 0" 
              :key="subItem.id"
              :menuItem="subItem" 
							:eventItem="eventItem"
              :backpage="getBackpage" 
              :icon="subItem.icon ?? ''" 
              :pathTo = "pathTo +'/'+ subItem.alias"
              :menuClass="(!page) ? 'btn-coesia '+ btnClass : 'btn-list text-uppercase'" />
              
            <MenuItem  
              v-if="subItem.type !== 'link' && subItem.type !== 'pdf' 
              && (subpage || !subItem.items || menuItem.items.length == 0)" 
              :key="subItem.id"
              :menuItem="subItem" 
              :icon="subItem.icon ?? ''" 
              isSubmenu = false
              :pathTo = "pathTo +'/'+ subItem.alias"
              :menuClass="(!page) ? 'btn-coesia '+ btnClass : 'btn-list text-uppercase'" />
              
            <PdfMenuItem  
              v-if="subItem.type === 'pdf'" 
              :key="subItem.id"
              :menuItem="subItem" 
              :menuClass="(!page) ? 'btn-coesia '+ btnClass : 'btn-list text-uppercase'" />
              
            <MenuItem  
              v-if="subItem.type == 'link'" 
              :key="subItem.id"
              :menuItem="subItem" 
              :icon="subItem.icon ?? ''" 
              :pathTo = "subItem.text"
              :menuClass="(!page) ? 'btn-coesia '+ btnClass : 'btn-list text-uppercase'" />
          </div>
        </div>

        <div v-if="menuItem.type == 'contacts'" class="contactlist">
          <ContactList 
            :page="menuItem" 
            :type="menuItem.id" 
            :eventItem="eventItem" 
            :ContactItems = "ContactItems"
            :pathTo = "pathTo"
            />
        </div>

        <div v-if="menuItem.type == 'page'" class="row">
          <EventPage :pageItem="menuItem"  />
        </div>

        <div v-if="menuItem.type == 'gallery'" class="gallery">
          <GalleryPage 
            :pageTitle="eventItem.title" 
            :pageItem="menuItem" />
        </div>

        <div v-if="menuItem.type == 'events'" class="eventlist">
          <h2 v-if="page">{{menuItem.title}}</h2>
          <EventsListItem v-for="eventItems in menuItem.items"
            :key="eventItems.id"
            :pageTitle="eventItem.title" 
            :pathTo = "pathTo +'/day-'+ eventItem.id"
            :backpage="events" 
            />
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OfflineMode from '../OfflineMode';
import MenuItem from './MenuItem';
import PdfMenuItem from './PdfMenuItem';
import MenuItemSubMenu from './MenuItemSubMenu';
import EventPage from '../fairs/EventPage';
import NewsList from '../fairs/NewsList';
import ContactList from '../contacts/ContactList';
import GalleryPage from '../gallery/GalleryPage';
import EventsListItem from '../events/EventsListItem';

export default {
  name: 'PageLayout',
  props: ['id', 'page', 'subpage', 'endpage'],
  data () {
    return {
      publicPath: process.env.BASE_URL,
      btnClass: 'col-12',
      search: ""
    }
  },
  watch: {
    user() {
			if (this.user) {
				let userState = this.contactType(this.id, this.user.id)
				//console.log('WATCH',  userState)
				if (!userState) {
					this.$router.push('/events')
				}
        if (userState.isparticipant && !userState.confirmed) {
          this.$router.push('/events/' + this.id + '/presence')
        }
			}
    }
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
  },
  computed: {
    ...mapGetters([
      "user",
			"contactType",
			"getBackpage",
      "token"
    ]),
    pathTo () {
      let path = '/events/'+ this.id;
      if (this.page) path += '/'+ this.page;
      if (this.subpage) path += '/'+ this.subpage;
      if (this.endpage) path += '/'+ this.endpage;
      return path;
    },
    eventItem () {
			let eventItem = this.$store.getters.fairItemFromId(this.id);
			if (eventItem) window.document.title = "Coesia Events Portal - "+ eventItem.title
      return eventItem
    },
    menuItem () {
      let parentItem;
      let menuItem = this.eventItem;
      if (this.page) {
        parentItem = menuItem;
        menuItem = parentItem.items.find(item => item.alias === this.page);
      }
      if (this.subpage) {
        parentItem = menuItem;
        menuItem = parentItem.items.find(item => item.alias === this.subpage);
      }
      if (this.endpage) {
        parentItem = menuItem;
        menuItem = parentItem.items.find(item => item.alias === this.endpage);
      }
      let type = menuItem.type
      if (type.indexOf('list') !== -1) menuItem.type = 'list'
      //console.log(menuItem);
      return menuItem;
    },
    ContactItems () {
      if (!this.subpage) return null
      //console.log("Get ContactItems - search: "+ this.search)
      let contacts = this.$store.getters.contactItemFromType(this.eventItem.id, this.subpage)
      if (this.search !== "" && this.subpage === 'participants') {
        let search = this.search.toLowerCase()
        contacts = contacts.filter(contactItem => 
          contactItem.title.toLowerCase().indexOf(search) !== -1 ||
          (contactItem.company && contactItem.company.toLowerCase().indexOf(search) !== -1) || 
          (contactItem.unit && contactItem.unit.toLowerCase().indexOf(search) !== -1) || 
          (contactItem.role && contactItem.role.toLowerCase().indexOf(search) !== -1)
        );
      }
      return contacts
    },
  },
  updated() {
    if (this.page == 'rooms' && this.subpage == 'booking') {
      this.$store.dispatch('getbookingItems', this.token)
    }
  },
  created() {
    if (this.user) {
				let userState = this.contactType(this.id, this.user.id)
        //console.log('created',  userState)
				if (!userState) {
					this.$router.push('/events')
				}
        if (userState.isparticipant && !userState.confirmed) {
          this.$router.push('/events/' + this.id + '/presence')
        }
      }
  },
  components: {
    MenuItem,
    MenuItemSubMenu,
    PdfMenuItem,
    EventPage,
		NewsList,
    ContactList,
    GalleryPage,
    EventsListItem,
    OfflineMode
  }
}
</script>

<style>
</style>

<style scoped>
#search-box {
  top: 55px;
  background-color: #DDDDDD;
}
</style>
